var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    d: "M16 0c8.8306404 0 16 7.1693596 16 16s-7.1693596 16-16 16S0 24.8306404 0 16 7.1693596 0 16 0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 0,
    y: 0,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "rgb(54,216,150)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 3,
    mask: "url(#mask-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(54,216,150)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 3,
    d: "M23.61538462 10l-8.7032967 12-6.52747254-6.85714286"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirma);
export default __webpack_public_path__ + "static/media/confirma.7d491283a47ddf8c40edf23b73b3aae4.svg";
export { ForwardRef as ReactComponent };